<script setup lang="ts">
import { ref, mergeProps } from "vue";

const model = defineModel<Date>({ default: new Date() });
const { minDate = null, maxDate = null } = defineProps<{
	minDate?: Date | null;
	maxDate?: Date | null;
}>();

const isMenuOpen = ref(false);
</script>

<template>
	<v-menu
		v-model="isMenuOpen"
		:close-on-content-click="false"
		location="bottom"
	>
		<template v-slot:activator="{ props }">
			<v-text-field
				:model-value="model?.toLocaleDateString() ?? ''"
				readonly
				v-bind="mergeProps($attrs, props)"
			>
				<template #append-inner>
					<v-icon>mdi-calendar</v-icon>
				</template>
			</v-text-field>
		</template>
		<vc-date-picker
			@dayclick="
				(_, event) => {
					isMenuOpen = false;
					event.target.blur();
				}
			"
			:is-dark="false"
			show-iso-weeknumbers
			:first-day-of-week="2"
			:popover="{ placement: 'auto' }"
			:attributes="[{ key: 'today', dot: true, dates: new Date() }]"
			v-model="model"
			:min-date="minDate"
			:max-date="maxDate"
			is-required
		>
		</vc-date-picker>
	</v-menu>
</template>

<style scoped lang="scss"></style>
